import { createContext } from 'react';
import type { StreamType } from './payloads';

export type StreamHandler = (type: StreamType, data: unknown) => void;

/** How recent the live data is (epoch ms). Read on demand, never a reason to re-render by itself. */
export interface StreamStats {
  /** first time the stream opened in this page load */
  openedAt: number | null;
  /** last message of any kind, keepalive `ping` included */
  lastMessageAt: number | null;
  /** last reads (`events`) or heartbeat/status (`gateway`) per gateway id */
  gatewayAt: ReadonlyMap<string, number>;
}
export interface StreamCtx {
  connected: boolean;
  subscribe: (h: StreamHandler) => () => void;
  stats: () => StreamStats;
}

const NO_STATS: StreamStats = { openedAt: null, lastMessageAt: null, gatewayAt: new Map() };
export const StreamContext = createContext<StreamCtx>({ connected: false, subscribe: () => () => undefined, stats: () => NO_STATS });
